/**
 * Do not edit directly
 * Generated on Tue, 05 Aug 2025 14:28:15 GMT
 */

export const PaddingSpacingNone = 0;
export const PaddingSpacing3Xs = 4;
export const PaddingSpacing2Xs = 8;
export const PaddingSpacingXs = 12;
export const PaddingSpacingS = 20;
export const PaddingSpacingSm = 24;
export const PaddingSpacingM = 32;
export const PaddingSpacingMl = 40;
export const PaddingSpacingL = 48;
export const PaddingSpacingXl = 56;
export const PaddingSpacing2Xl = 64;
export const PaddingSpacing3Xl = 80;
export const PaddingSpacing4Xl = 128;
export const SizingXs = 2;
export const SizingS = 4;
export const SizingM = 8;
export const SizingL = 12;
export const SizingXl = 16;
export const SizingXxl = 24;
export const SizingXxxl = 32;
export const RadiusXs = 4;
export const RadiusS = 8;
export const RadiusM = 12;
export const RadiusL = 16;
export const RadiusXl = 16;
export const RadiusXxl = 32;
export const RadiusXxxl = 48;
export const FontFamiliesPrimary = "Instrument Sans";
export const FontFamiliesSecondary = "Space Grotesk";
export const LineHeights100 = 16;
export const LineHeights200 = 18;
export const LineHeights300 = 20;
export const LineHeights400 = 24;
export const LineHeights500 = 28;
export const LineHeights600 = 32;
export const LineHeights700 = 36;
export const LineHeights800 = 40;
export const LineHeights900 = 48;
export const LineHeights1000 = 64;
export const LineHeights1100 = 84;
export const FontWeights400 = "Regular";
export const FontWeights500 = "Medium";
export const FontWeights700 = "Bold";
export const FontWeightsItalic = "Italic";
export const FontSize100 = 13;
export const FontSize200 = 16;
export const FontSize300 = 18;
export const FontSize400 = 20;
export const FontSize500 = 24;
export const FontSize600 = 30;
export const FontSize700 = 36;
export const FontSize800 = 48;
export const FontSize900 = 64;
export const LetterSpacing0 = "0%";
export const LetterSpacing1 = "3%";
export const LetterSpacing2 = "10%";
export const ParagraphSpacing0 = 0;
export const ParagraphSpacing1 = 10;
export const MobileH1FontFamily = "Instrument Sans";
export const MobileH1FontWeight = "Bold";
export const MobileH1LineHeight = 40;
export const MobileH1FontSize = 30;
export const MobileH1TextDecoration = "none";
export const MobileH2FontFamily = "Instrument Sans";
export const MobileH2FontWeight = "Bold";
export const MobileH2LineHeight = 36;
export const MobileH2FontSize = 24;
export const MobileH2TextDecoration = "none";
export const MobileH3FontFamily = "Instrument Sans";
export const MobileH3FontWeight = "Bold";
export const MobileH3LineHeight = 32;
export const MobileH3FontSize = 20;
export const MobileH3TextDecoration = "none";
export const MobileH4FontFamily = "Instrument Sans";
export const MobileH4FontWeight = "Bold";
export const MobileH4LineHeight = 28;
export const MobileH4FontSize = 18;
export const MobileH4TextDecoration = "none";
export const MobileH5FontFamily = "Instrument Sans";
export const MobileH5FontWeight = "Bold";
export const MobileH5LineHeight = 24;
export const MobileH5FontSize = 16;
export const MobileH5TextDecoration = "none";
export const MobileH6FontFamily = "Space Grotesk";
export const MobileH6FontWeight = "Medium";
export const MobileH6LineHeight = 28;
export const MobileH6FontSize = 18;
export const MobileH6TextDecoration = "none";
export const MobileSubtitleFontFamily = "Space Grotesk";
export const MobileSubtitleFontWeight = "Regular";
export const MobileSubtitleLineHeight = 24;
export const MobileSubtitleFontSize = 16;
export const MobileSubtitleTextDecoration = "none";
export const MobileButtonFontFamily = "Space Grotesk";
export const MobileButtonFontWeight = "Bold";
export const MobileButtonLineHeight = 16;
export const MobileButtonFontSize = 16;
export const MobileButtonTextDecoration = "none";
export const MobileButtonLetterSpacing = "3%";
export const MobileButtonSmallFontFamily = "Space Grotesk";
export const MobileButtonSmallFontWeight = "Regular";
export const MobileButtonSmallLineHeight = 16;
export const MobileButtonSmallFontSize = 13;
export const MobileButtonSmallTextDecoration = "none";
export const MobileButtonSmallLetterSpacing = "3%";
export const MobileBodyFontFamily = "Instrument Sans";
export const MobileBodyFontWeight = "Regular";
export const MobileBodyLineHeight = 24;
export const MobileBodyFontSize = 16;
export const MobileBodyTextDecoration = "none";
export const MobileBodyParagraphSpacing = 10;
export const MobileBodyStrongFontFamily = "Instrument Sans";
export const MobileBodyStrongFontWeight = "Bold";
export const MobileBodyStrongLineHeight = 24;
export const MobileBodyStrongFontSize = 16;
export const MobileBodyStrongTextDecoration = "none";
export const MobileBodyStrongParagraphSpacing = 10;
export const MobileBodyItalicFontFamily = "Instrument Sans";
export const MobileBodyItalicFontWeight = "Italic";
export const MobileBodyItalicLineHeight = 24;
export const MobileBodyItalicFontSize = 16;
export const MobileBodyItalicTextDecoration = "none";
export const MobileBodyItalicParagraphSpacing = 10;
export const MobileBodyLinkFontFamily = "Instrument Sans";
export const MobileBodyLinkFontWeight = "Regular";
export const MobileBodyLinkLineHeight = 24;
export const MobileBodyLinkFontSize = 16;
export const MobileBodyLinkTextDecoration = "underline";
export const MobileBodyLinkParagraphSpacing = 10;
export const MobileBodySmallFontFamily = "Instrument Sans";
export const MobileBodySmallFontWeight = "Regular";
export const MobileBodySmallLineHeight = 20;
export const MobileBodySmallFontSize = 13;
export const MobileBodySmallTextDecoration = "none";
export const MobileBodySmallStrongFontFamily = "Instrument Sans";
export const MobileBodySmallStrongFontWeight = "Bold";
export const MobileBodySmallStrongLineHeight = 20;
export const MobileBodySmallStrongFontSize = 13;
export const MobileBodySmallStrongTextDecoration = "none";
export const MobileBodySmallItalicFontFamily = "Instrument Sans";
export const MobileBodySmallItalicFontWeight = "Italic";
export const MobileBodySmallItalicLineHeight = 20;
export const MobileBodySmallItalicFontSize = 13;
export const MobileBodySmallItalicTextDecoration = "none";
export const MobileBodySmallLinkFontFamily = "Instrument Sans";
export const MobileBodySmallLinkFontWeight = "Regular";
export const MobileBodySmallLinkLineHeight = 20;
export const MobileBodySmallLinkFontSize = 13;
export const MobileBodySmallLinkTextDecoration = "underline";
export const MobileCategoryFontFamily = "Space Grotesk";
export const MobileCategoryFontWeight = "Bold";
export const MobileCategoryLineHeight = 20;
export const MobileCategoryFontSize = 13;
export const MobileCategoryTextDecoration = "none";
export const MobileCategoryLetterSpacing = "10%";
export const MobileTagFontFamily = "Space Grotesk";
export const MobileTagFontWeight = "Medium";
export const MobileTagLineHeight = 20;
export const MobileTagFontSize = 13;
export const MobileTagTextDecoration = "none";
export const MobileCaptionFontFamily = "Space Grotesk";
export const MobileCaptionFontWeight = "Regular";
export const MobileCaptionLineHeight = 20;
export const MobileCaptionFontSize = 13;
export const MobileCaptionTextDecoration = "none";
export const MobileLabelFontFamily = "Instrument Sans";
export const MobileLabelFontWeight = "Medium";
export const MobileLabelLineHeight = 18;
export const MobileLabelFontSize = 13;
export const MobileLabelTextDecoration = "none";
export const MobilePlaceholderFontFamily = "Space Grotesk";
export const MobilePlaceholderFontWeight = "Medium";
export const MobilePlaceholderLineHeight = 16;
export const MobilePlaceholderFontSize = 13;
export const MobilePlaceholderTextDecoration = "none";
export const TextDecorationNone = "none";
export const TextDecorationUnderline = "underline";
export const ComponentButtonPaddingLeft = 22;
export const ComponentButtonPaddingRight = 22;
export const ComponentButtonPaddingTop = 14;
export const ComponentButtonPaddingBottom = 14;
export const Numbers0 = 0;
export const Numbers2 = 2;
export const Numbers4 = 4;
export const Numbers8 = 8;
export const Numbers12 = 12;
export const Numbers14 = 14;
export const Numbers16 = 16;
export const Numbers20 = 20;
export const Numbers22 = 22;
export const Numbers24 = 24;
export const Numbers32 = 32;
export const Numbers40 = 40;
export const Numbers48 = 48;
export const Numbers56 = 56;
export const Numbers64 = 64;
export const Numbers80 = 80;
export const Numbers96 = 96;
export const Numbers128 = 128;
export const Numbers160 = 160;
export const Numbers248 = 240;
